import React from 'react';

const BusStopForm = ({ formData, onInputChange, onSubmit }) => {

  const isFormValid = () => {
    return (
      formData.title?.trim() &&
      formData.arrival_time?.trim() &&
      formData.address?.trim() &&
      formData.latitude !== '' &&
      formData.longitude !== ''
    );
  };


  return (
    <form onSubmit={onSubmit}>

      <div className="mb-3 mt-3">
        <label htmlFor="title" className="form-label">
          Título
        </label>
        <input
          type="text"
          className="form-control"
          id="title"
          name="title"
          placeholder="Ej: Micro - Independiente vs Racing"
          onChange={onInputChange}
          value={formData.title}
        />
      </div>

      <div className="mb-3">
        <label htmlFor="arrival_time" className="form-label">
          Hora de llegada
        </label>
        <input
          type="time"
          className="form-control"
          id="arrival_time"
          name="arrival_time"
          onChange={onInputChange}
          value={formData.arrival_time}
        />
      </div>

      <div className="mb-3">
        <label htmlFor="address" className="form-label">
          Dirección
        </label>
        <input
          type="text"
          className="form-control"
          id="address"
          name="address"
          placeholder="Se completa automáticamente al seleccionar en el mapa"
          onChange={onInputChange}
          value={formData.address}
        />
        <small className="form-text text-muted">
          Podés editar la dirección manualmente si es necesario.
        </small>
      </div>

      <div className="mb-3">
        <label htmlFor="latitude" className="form-label">Latitud</label>
        <input
          type="number"
          step="any"
          className="form-control"
          id="latitude"
          name="latitude"
          placeholder="Ej: -34.920500"
          onChange={onInputChange}
          value={formData.latitude}
        />
      </div>

      <div className="mb-3">
        <label htmlFor="longitude" className="form-label">Longitud</label>
        <input
          type="number"
          step="any"
          className="form-control"
          id="longitude"
          name="longitude"
          placeholder="Ej: -57.953600"
          onChange={onInputChange}
          value={formData.longitude}
        />
        <small className="form-text text-muted">
          Podés obtener las coordenadas desde Google Maps tocando el punto deseado.
        </small>
      </div>

      <div className="mb-3 form-check">
        <input
          type="checkbox"
          className="form-check-input"
          id="is_active"
          name="is_active"
          checked={formData.is_active}
          onChange={onInputChange}
        />
        <label className="form-check-label" htmlFor="is_active">
          Activo
        </label>
      </div>

      <button
        type="submit"
        style={{
          backgroundColor: '#C73B33',
          borderColor: '#FF5733',
          color: '#FFF',
        }}
        className="btn"
        disabled={!isFormValid()}
      >
        Crear Ubicación de Micro
      </button>

    </form>
  );
};

export default BusStopForm;
